export const USER_NAME = 'USER_NAME';
export const PASSWORD = 'PASSWORD';
export const REMEMBER = 'REMEMBER';
export const UNIT_ID = 'UNIT_ID';
export const IS_LOGGED_IN = 'ISLOGGED_IN';
export const PROPERTY_ID = 'PROPERTY_ID';
export const T_CODE = 'T_CODE';
export const PMS_TYPE = 'PMS_TYPE';
export const TOKEN = 'access_token';
export const CONDO_CORP_NAME = 'CONDO_CORP_NAME';
export const CONDO_CORP_ID = 'CONDO_CORP_ID';
export const PROPERTY_MANAGER_ID = 'PROPERTY_MANAGER_ID';
export const PUSH_MESSAGE = 'PUSH_MESSAGE';
export const ZIP_POSTAL = 'ZIP_POSTAL';
export const DEFAULT_BUILDING = 'MTCC3275';
export const SEARCH_BAR_POP_OVER = 'SEARCH_BAR_POP_OVER';
export const EXPLORE_PROPERTY = 'EXPLORE_PROPERTY';
